import React, {Component} from 'react';
import {connect, dispatch} from 'react-redux';
import {bindActionCreators} from 'redux';
import Typekit from 'react-typekit';

import {fetchCategoryPosts, getTaxIdFromSlug, ROUTER} from '../actions/index';

import MapFull from '../components/map-full';


class MapperCategory extends Component {
    constructor(props) {
	    super(props);
	    this.state = {
		    cat: 0,
		    mapView: true,
		    zoom: 11,
			center:{lat:39.968957, lng:-75.754447}	    
		};

	}
	    
    componentWillMount() {
        //if (this.props.location.search){
        	//let cat_slug = this.props.location.search.replace("?category=" , "")
        //}
        switch (this.props.location.search.replace("?category=" , "")) {
	        case 'wineries':
	        	this.setState(state => ({
			      cat: 289,
			    }));
			    break;
			case 'breweries':
	        	this.setState(state => ({
			      cat: 291,
			    }));
			    break;
			case 'spirits':
	        	this.setState(state => ({
			      cat: 292,
			    }));
			    break;
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.pageNum !== nextProps.match.params.pageNum || this.props.location.pathname !== nextProps.location.pathname) {
            if (this.props.location.search){
            	this.props.fetchCategoryPosts('cc-posts', this.state.cat);
            }
            this.props.dispatch({
                type: ROUTER,
                payload: nextProps.match
            });
        }
    }

	componentDidMount(){
        if (this.state.cat != 0){
        	this.props.fetchCategoryPosts('cc-posts', this.state.cat);
        }
        this.props.dispatch({
           type: ROUTER,
           payload: this.props.match
        });
	}
    

     render() {
        return (
            <section className="kiosk-wrapper">
	            <div className="kiosk-wrapper">
					<div className="map-wrapper">
		                <Typekit kitId="eab1tpm" />
		                <MapFull 
		                	zoom={this.state.zoom}
		                	center={this.state.center}
		                	category={this.props.location.search.replace("?category=" , "")}
		                />
	                </div>
	            </div>
            </section>
        );

    }
}

function mapStateToProps(state) {
	return {
		tags: state.tags,
		selectedCat: state.selectedCat,
		router: state.router
	};
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({fetchCategoryPosts, getTaxIdFromSlug, dispatch}), dispatch)
  
}

export default connect(mapStateToProps, mapDispatchToProps)(MapperCategory)


// WEBPACK FOOTER //
// ./src/containers/mapper-category.js